var maintenanceIncidentDataGenerator = function (type) {
    var finalArray = [];
    for (var indx = 0; indx < 100; ++indx) {
        finalArray.push({
            id: type === "M" ? "MN" + (1001 + indx) : "IN" + (1001 + indx),
            title: "Title for ".concat(type === "M" ? "maintenance" : "incident", " # \" ").concat((indx + 1)),
            status: type === "M" ? (indx % 2 === 0 ? "Upcoming" : "Closed") : (indx % 2 === 0 ? "Detected" : "Restored"),
            start: 1630710147000,
            end: 1630820147000,
            createdBy: indx % 2 === 0 ? "akaushik1" : "ujjwal.lal",
            priority: indx % 2 === 0 ? "P1" : "P3",
            updated: 1630920147000,
            ticket: indx % 2 === 0 ? "SN12345678" : "CH65102835"
        });
    }
    return finalArray;
};
var siteAlertDataGenerator = function () {
    var finalArray = [];
    for (var indx = 0; indx < 100; ++indx) {
        finalArray.push({
            id: "SA" + (1001 + indx),
            title: "Title for Site Alert #" + (indx + 1),
            status: (indx % 2 === 0 ? "Detected" : "Restored"),
            start: 1630710147000,
            end: 1630820147000,
            alertType: indx % 2 === 0 ? "Informational" : "Issue",
            issueType: indx % 2 === 0 ? "Complete site change" : "Technical error",
            refreshType: indx % 2 === 0 ? "IAV" : "Add Account"
        });
    }
    return finalArray;
};
var subscriptionDataGenerator = function () {
    var finalArray = [];
    for (var indx = 0; indx < 88; ++indx) {
        finalArray.push({
            userName: "UN" + (1001 + indx),
            name: "User's name #" + (indx + 1),
            cobrand: (indx % 2 === 0 ? "JP Morgan Chase" : "Lumin"),
            email: "test@test.com",
            phone: "+1 (485) 495-9857",
            timezone: (indx % 2 === 0 ? "EST" : "CST"),
            environment: (indx % 2 === 0 ? "Staging" : "Production"),
            myYodleeUser: (indx % 2 === 0 ? "Yes" : "No"),
            accountCreated: 1630790147000,
            lastModified: 1630840147000,
        });
    }
    return finalArray;
};
export var MaintenanceList = {
    data: maintenanceIncidentDataGenerator("M"),
    pageNo: 1,
    pageSize: 50
};
export var IncidentList = {
    data: maintenanceIncidentDataGenerator("I"),
    pageNo: 1,
    pageSize: 50
};
export var SiteAlertList = {
    data: siteAlertDataGenerator(),
    pageNo: 1,
    pageSize: 50
};
export var SubscriptionList = {
    data: subscriptionDataGenerator(),
    pageNo: 1,
    pageSize: 50
};
//# sourceMappingURL=mock-data.js.map